var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShopRemove = function SvgShopRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#850000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.007 11.219v4.49c0 4.49-1.79 6.29-6.29 6.29h-5.39c-.58 0-1.11-.03-1.6-.1M3.04 15.519v-4.3",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#850000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.034 12c1.83 0 3.18-1.49 3-3.32L14.364 2h-4.67l-.67 6.68c-.18 1.83 1.18 3.32 3.01 3.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#850000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.33 12c2.02 0 3.5-1.64 3.3-3.65l-.28-2.75C20.99 3 19.99 2 17.37 2h-3.05l.7 7.01c.18 1.65 1.66 2.99 3.31 2.99ZM5.672 12c1.65 0 3.14-1.34 3.3-2.99l.22-2.21.48-4.8h-3.05c-2.62 0-3.62 1-3.98 3.6l-.28 2.75c-.2 2.01 1.29 3.65 3.31 3.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#850000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9 19c0 .75-.21 1.46-.58 2.06-.19.32-.42.61-.69.84-.03.04-.06.07-.1.1-.7.63-1.62 1-2.63 1-1.22 0-2.31-.55-3.03-1.41-.02-.03-.05-.05-.07-.08-.12-.14-.23-.29-.32-.45C1.21 20.46 1 19.75 1 19c0-1.26.58-2.39 1.5-3.12.17-.14.35-.26.54-.36C3.62 15.19 4.29 15 5 15c1 0 1.9.36 2.6.97.12.09.23.2.33.31C8.59 17 9 17.95 9 19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#850000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.488 18.98h-2.98",
    opacity: 0.4
  })));
};
export default SvgShopRemove;